module.exports = __webpack_public_path__ + "img/DSC_7414-1-3.22548180.jpeg";